import ActionProps from './ActionProps'

let KendoDialogAction = {
    name: 'kendo-dialog-action',
    render () {
        return null
    },
    mixins: [ActionProps]
}

export default KendoDialogAction


// WEBPACK FOOTER //
// ./packages/kendo-dialog-vue-wrapper/src/KendoDialog/KendoDialogAction.js